import { createContext } from 'react';
export const AppContext = createContext();
export const AccessContext = createContext();
export const BranchItemsContext = createContext();
export const LoaderContext = createContext();